import { getItems } from 'common/api/financierProducts';

import {
    FETCH_ALL_FINANCIER_PRODUCTS,
    FETCH_ALL_FINANCIER_PRODUCTS_FAILURE,
    FETCH_ALL_FINANCIER_PRODUCTS_SUCCESS,
} from '../actionTypes';
import { installersActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(installersActions[FETCH_ALL_FINANCIER_PRODUCTS]());

    getItems()
        .then((response) =>
            dispatch(
                installersActions[FETCH_ALL_FINANCIER_PRODUCTS_SUCCESS](
                    response.data.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                installersActions[FETCH_ALL_FINANCIER_PRODUCTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
